export default __webpack_public_path__ + "static/media/logo_ecert.8faad1e7.svg";